// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { Status as UILibraryStatus } from '@plesk/ui-library';

export const Status = styled(UILibraryStatus)`
  vertical-align: bottom;
  padding-right: 5px;
`;
